'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'chess-knight-piece';
var width = 384;
var height = 512;
var aliases = ["chess-knight-alt"];
var unicode = 'f442';
var svgPathData = 'M208 0c88.4 0 160 71.6 160 160l0 126.9c0 11.1-3.3 22-9.5 31.3L304 400 358.1 454.1c6.4 6.4 9.9 15 9.9 24 0 18.7-15.2 33.9-33.9 33.9L49.9 512c-18.7 0-33.9-15.2-33.9-33.9 0-9 3.6-17.6 9.9-24L80 400 71 354.9c-4.3-21.3 4.1-43.2 21.5-56.2l99.5-74.7-48 0-12.1 12.1c-12.7 12.7-30 19.9-48 19.9l-4.6 0c-34.9 0-63.2-28.3-63.2-63.2 0-21 8.3-41.1 23.2-55.9L112 64 112 28.2C112 12.7 124.6 0 140.2 0L208 0zM176 104a24 24 0 1 0 0 48 24 24 0 1 0 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessKnightPiece = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;